import { useDispatch } from 'react-redux';
import { axiosPrivate } from '../../api/axios';
import { API_URL } from '../../api/constants';
import useAuth from './useAuth';

const useRefreshToken = () => {
  const { auth, login } = useAuth();
  const dispatch = useDispatch();

  const refresh = async () => {
    const controller = new AbortController();
    try {
      const response = await axiosPrivate.get(API_URL.REFRESH, {
        signal: controller.signal,
        timeout: 3000,
      });

      if (response.status === 200) {
        const newToken = response.data.id_token;
        dispatch(
          login({
            ...auth.user,
            token: newToken,
          })
        );
        return newToken;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      controller.abort();
    } finally {
      return null;
    }
  };

  return refresh;
};

export default useRefreshToken;
